const findInNestedArray = (allData, childrenField, field, value) => {
  const filteredData = allData.find(data => data[field] === value);

  if (filteredData) {
    return filteredData;
  }

  return allData.reduce((acc, data) => {
    if (data[childrenField]) {
      const filteredInChild = findInNestedArray(data[childrenField], childrenField, field, value);

      if (filteredInChild) {
        acc = filteredInChild;
      }
    }

    return acc
  }, null);

}

export default findInNestedArray;
